// extracted by mini-css-extract-plugin
module.exports = {"Title":"orderhistory_Title__3UQkF","factory":"orderhistory_factory__3ALKN","PostProcess":"orderhistory_PostProcess__25Nme","PaymentStatus":"orderhistory_PaymentStatus__2Rt7t"};